import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WishList } from '@app/shared/models/product';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import { HttpHeaders } from '@angular/common/http';
import {APIResponse} from '@app/shared/services/core/ICore.interface';
import {GetWishListInterface} from '@app/feature/end-user/services/wishlist/GetWishList.interface';
@Injectable({
  providedIn: 'root'
})
export class WishlistService {

  constructor(private httpClient: HttpClient) {
   }

   /** adds item to wishlist */
   AddItemToWishList(wishListModel: WishList) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
         return this.httpClient.post(environment.baseUrl + AppConstant.AddItemToWishList, wishListModel , {headers: headers_1});
  }
  /** get item to wishlist */
  GetWishList(storeId: any, userId: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.get<APIResponse<GetWishListInterface[]>>(environment.baseUrl + AppConstant.GetWishList + '?UserId=' + userId +
    '&StoreId=' + storeId, {headers: headers_1});
  }
  /** delete item to wishlist */
  DeleteFromWishList(wishlistId: number, userId: number, flag: boolean) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.get<any>(environment.baseUrl + AppConstant.DeleteFromWishList + '?WishlistId=' + wishlistId +
     '&UserId=' + userId +'&flag='+flag, {headers: headers_1});
  }
}
